import { useQuery } from '@tanstack/react-query';
import { apiRoutes } from '../../../constants/apiRoutes';
import { getAxios } from '../../../util/axios';
import { EmailAutomationWorkerHealth } from '../types/EmailAutomationWorkerHealth';

export const emailAutomationWorkerHealthQueryKey = ['emailAutomation', 'workerHealth'];

export const useEmailAutomationWorkerHealthQuery = () => {
  return useQuery({
    queryKey: emailAutomationWorkerHealthQueryKey,
    queryFn: async () =>
      (await getAxios().get<EmailAutomationWorkerHealth[]>(apiRoutes.emailAutomation.workers.health())).data,
    refetchInterval: 60_000
  });
};
